const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { FullSizeSpinner } from '@/common/components/ui/FullSizeSpinner';
import { isHttpError } from '@/common/utils/isHttpError';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
import { getScenarioQueryOptions } from '@/features/planner/queries/useGetScenario';
import { getTimelineItemsDataSetQueryOptions } from '@/features/planner/queries/useGetTimelineItemsDataSet';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/')({
  loader: async ({
    params: {
      loopId,
      scenarioId,
      org
    },
    context: {
      queryClient
    }
  }) => {
    try {
      await Promise.all([queryClient.ensureQueryData(getScenarioQueryOptions({
        loopId,
        scenarioId
      })), queryClient.ensureQueryData(getTimelineItemsDataSetQueryOptions({
        loopId,
        scenarioId
      }))]);
      return {
        scenarioId
      };
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }
      if (isHttpError(error, 404)) {
        throw redirect({
          to: '/org/$org/loop/$loopId/planner',
          params: {
            org,
            loopId
          }
        });
      }
      throw error;
    }
  },
  validateSearch: zodValidator(itemPanelSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: FullSizeSpinner
});